import React, { useEffect } from "react";
import "./App.scss";
import Routing from "./Routes";
import { useSelector } from "react-redux";
import { RootState } from "./store";

const App = () => {
  const { token, isAuthenticated } = useSelector(
    (state: RootState) => state.auth
  );

  // Log authentication state on mount (for debugging persistence)
  useEffect(() => {
    if (token && isAuthenticated) {
      console.log("✅ User is authenticated. Token persisted:", !!token);
    } else {
      console.log("ℹ️ User is not authenticated");
    }
  }, [token, isAuthenticated]);

  return <Routing />;
};

export default App;
